export const NOTIFICATION_TYPES = [
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_CREATED',
    value: 'conversation_creation',
    description: 'Toda vez que QUALQUER conversa nova entra na conta. Recomendado apenas pra administradores — agentes recebem ruido demais.',
    adminOnly: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ASSIGNED',
    value: 'conversation_assignment',
    description: 'Quando uma conversa e atribuida especificamente a voce — voce e o agente responsavel.',
    adminOnly: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_MENTION',
    value: 'conversation_mention',
    description: 'Quando alguem menciona voce com @ em uma nota interna de conversa.',
    adminOnly: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE',
    value: 'assigned_conversation_new_message',
    description: 'Cada nova mensagem em conversa que esta atribuida a voce.',
    adminOnly: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE',
    value: 'participating_conversation_new_message',
    description: 'Cada nova mensagem em conversa que voce ja participou (mesmo nao atribuida).',
    adminOnly: false,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_FIRST_RESPONSE',
    value: 'sla_missed_first_response',
    description: 'Conversa atribuida a voce passou do prazo de SLA para primeira resposta.',
    adminOnly: false,
    requiresSla: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_NEXT_RESPONSE',
    value: 'sla_missed_next_response',
    description: 'Conversa atribuida a voce passou do prazo de SLA para proxima resposta.',
    adminOnly: false,
    requiresSla: true,
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_RESOLUTION',
    value: 'sla_missed_resolution',
    description: 'Conversa atribuida a voce passou do prazo de SLA para resolucao.',
    adminOnly: false,
    requiresSla: true,
  },
];

// Phase 2.7: linhas adicionais mostradas quando account tem voip_calls feature flag.
// Apos feedback do user (v117): manter apenas Venda Fechada — outros eventos VOIP
// estavam barulhentos demais e nao agregavam.
export const VOIP_NOTIFICATION_TYPES = [
  {
    label: 'Venda fechada',
    value: 'voip_sale_closed',
    description: 'Quando uma chamada VOIP marca o lead como venda fechada.',
    adminOnly: false,
  },
];

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];
